module.exports = __webpack_public_path__ + "static/media/angel.7a979516.svg";